import Papa from 'papaparse';
import * as XLSX from 'xlsx';

export function readCsvToRecords(
  file: File,
): Promise<Record<string, unknown>[]> {
  return new Promise((resolve, reject) => {
    Papa.parse(file, {
      header: true,
      skipEmptyLines: true,
      complete(result) {
        const data = (result.data ?? []) as Record<string, unknown>[];
        resolve(data);
      },
      error(err) {
        reject(err);
      },
    });
  });
}

export function readExcelToRecords(
  file: File,
): Promise<Record<string, unknown>[]> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      try {
        const data = new Uint8Array(e.target?.result as ArrayBuffer);
        const workbook = XLSX.read(data, {
          type: 'array',
          cellDates: true,
        });
        const sheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[sheetName];
        const json = XLSX.utils.sheet_to_json<Record<string, unknown>>(
          worksheet,
          {
            defval: '',
            raw: false,
          },
        );
        resolve(json);
      } catch (err) {
        reject(err);
      }
    };
    reader.onerror = () => reject(new Error('Error al leer el archivo'));
    reader.readAsArrayBuffer(file);
  });
}

const EXCEL_EXTENSIONS = /\.(xlsx|xls)$/i;
const CSV_EXTENSION = /\.csv$/i;

export async function readFileToRecords(
  file: File,
): Promise<Record<string, unknown>[]> {
  const name = file.name ?? '';
  if (CSV_EXTENSION.test(name)) {
    return readCsvToRecords(file);
  }
  if (EXCEL_EXTENSIONS.test(name)) {
    return readExcelToRecords(file);
  }
  return Promise.reject(
    new Error('Formato no soportado. Usa archivos .xlsx, .xls o .csv'),
  );
}
